import React from "react";

const Hero = () => {
    return (
        <section className="info">
            <div className="info__hero container">
                <h1>Patients & Families</h1>
                <p>
                    Care that goes beyond. From questions about your rights and
                    billing, to discovering care that seeks to elevate your
                    spirit as well as body, we are driven by a passion that
                    transcends boundaries.
                </p>
            </div>
        </section>
    );
};

export default Hero;
